import React, { FC } from 'react';
import { Props } from './types';
import { Container, ContentLoader } from './styles';

const Loader: FC<Props> = ({ opacity = 1 }) => {
  return (
    <Container>
      <ContentLoader viewBox="0 0 1184 72" $opacity={opacity}>
        <rect x="32" y="28" width="191" height="19" rx="10" />
        <rect x="275" y="28" width="121" height="19" rx="10" />
        <rect x="825" y="28" width="216" height="19" rx="10" />
        <rect x="471" y="28" width="105" height="19" rx="10" />
        <rect x="667" y="28" width="20" height="19" rx="10" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
